import { useRef } from 'react';

import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { IconAddPlus } from '@components/icons/add-plus';
import { Stack } from '@components/stack';

import { useStore } from 'models/Provider';

export const FileUploadAnother = observer(({ disabled, onChange }) => {
  const inputRef = useRef();
  const { t } = useStore();

  const changeFile = (e) => {
    const file = e.target.files.length > 0 ? e.target.files[0] : null;
    if (onChange) {
      onChange(file);
    }
  };

  const uploadClick = () => {
    inputRef.current.click();
  };

  return (
    <Stack space={0} orientation="horizontal" justify="flex-end">
      <Button
        variant="secondary"
        iconLeft={<IconAddPlus />}
        text={t('helpers.add')}
        isDisabled={disabled}
        onClick={uploadClick}
      />
      <input ref={inputRef} style={{ display: 'none' }} type="file" onChange={changeFile} />
    </Stack>
  );
});
